import { useState } from "react";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";
import { Box, Button, Grid, MobileStepper, useTheme } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import CustomTextField from "../../../CustomComponents/CustomTextField";

const DynamicTemplateFields = ({ dynamicTemplateFieldsList }) => {

    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
 
   const maxSteps = validate(dynamicTemplateFieldsList) ?  dynamicTemplateFieldsList.length : 0;
 
   const handleBack = () => {
     setActiveStep((prevActiveStep) => prevActiveStep - 1);
   };
 
   const handleNext = () => {
     setActiveStep((prevActiveStep) => prevActiveStep + 1);
   };
 
    const dynamicTemplateFieldsComponent = () => {
       const dynamicTemplateFields = validate(dynamicTemplateFieldsList) ? dynamicTemplateFieldsList[activeStep] : undefined;
       return (
          <Grid container rowSpacing={0} columnSpacing={2}>
           <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Field Data ID"
                 variant="standard"
                 placeholder="Enter Field Data ID"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.fieldDataId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Field Definition ID"
                 variant="standard"
                 placeholder="Enter Field Definition ID"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.fieldDefinitionId : ""}
               />
               </Grid>
           <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Internal Application ID"
                 variant="standard"
                 placeholder="Enter Internal Application ID"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.internalApplicationId : ""}
               />
               </Grid>
           <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Order Number"
                 variant="standard"
                 placeholder="Enter Order Number"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.orderNo : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Template ID"
                 variant="standard"
                 placeholder="Enter Template ID"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.templateId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Template Assessment ID"
                 variant="standard"
                 placeholder="Enter Template Assessment ID"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.templateAssessmentId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Attribute Name"
                 variant="standard"
                 placeholder="Enter Attribute Name"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.attributeName : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Category"
                 variant="standard"
                 placeholder="Enter Category"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.category : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Sub-Category"
                 variant="standard"
                 placeholder="Enter Sub-Category"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.subCategory : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Unit ID"
                 variant="standard"
                 placeholder="Enter Unit ID"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.unitId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Unit"
                 variant="standard"
                 placeholder="Enter Unit"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.unit : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Label"
                 variant="standard"
                 placeholder="Enter Label"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.label : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Value"
                 variant="standard"
                 placeholder="Enter Value"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.value : ""}
               />
               </Grid>
              
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Read Only"
                 variant="standard"
                 placeholder="Enter Read Only"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.readOnly : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Created By"
                 variant="standard"
                 placeholder="Enter Created By"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.createdBy : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Modified By"
                 variant="standard"
                 placeholder="Enter Modified By"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? dynamicTemplateFields.modifiedBy : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Created Date"
                 variant="standard"
                 placeholder="Enter Created Date"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? convertDateWithValidation(dynamicTemplateFields.createdDate) : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Modified Date"
                 variant="standard"
                 placeholder="Enter Modified Date"
                 disabled={true}
                 value={dynamicTemplateFields !== undefined ? convertDateWithValidation(dynamicTemplateFields.modifiedDate) : ""}
               />
               </Grid>
               </Grid>
       );
    }
 
     return(
          <AccordianContainer
           id="accord"
           title="Dynamic Template Fields"
           initialOpen={false}
         >
         <Box sx={{ marginTop: "-1%" }}>
         <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Box sx={{ display: "flex", justifyContent:"center", alignItems: "center", marginBottom: "8px"}}>
                         { maxSteps > 1 && <MobileStepper
                           variant="text"
                           steps={maxSteps}
                           position="static"
                           activeStep={activeStep}
                           sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }} 
                             nextButton={
                             <Button size="small" sx={{ color:"#003f7c" }} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                                 Next
                             {theme.direction === 'rtl' ? (
                             <KeyboardArrowLeft />
                             ) : ( <KeyboardArrowRight /> )}
                            </Button>
                          }
                         backButton={
                         <Button size="small" onClick={handleBack} sx={{ color:"#003f7c" }} disabled={activeStep === 0}>
                         {theme.direction === 'rtl' ? (
                             <KeyboardArrowRight />
                         ) : (
                             <KeyboardArrowLeft />
                         )}
                             Back
                         </Button>
                     }
                     /> }
                     </Box>
                     </Grid>
                     { dynamicTemplateFieldsComponent() }
         </Box>
         </AccordianContainer>
 );


}

export default DynamicTemplateFields;